import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js';

import { ReactNode } from 'react';
import stripeStyles from 'src/theme/stripeStyles';

const stripePromise = loadStripe(
  process.env.NODE_ENV === 'production'
    ? 'pk_live_4JV3S8UYJl6LjwBwUfKyUCJD'
    : 'pk_test_u2mSm0tSpCqIoMdF5MZImDMn',
);

interface StripeProviderProps {
  currency?: string;
  children: ReactNode;
}

export default function StripeProvider({ currency = 'usd', children }: StripeProviderProps) {
  const paymentMethodTypes = ['card', 'paypal'];

  const options: StripeElementsOptions = {
    ...stripeStyles,
    mode: 'subscription',
    amount: 0,
    currency,
    clientSecret: undefined,
    paymentMethodTypes,
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  );
}
